module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"tcpaLawsLink":"Read the TCPA laws","bestPracticesLink":"Review best practices","rulesAndRegulationsInfo":"Text messaging has many rules and regulations. Make sure you understand them."}}')
  delete Component.options._Ctor
}
